module.exports = __webpack_public_path__ + "static/img/h.8762a6aa.jpg";